import { api } from '@xtnd/web/shared/api';
import {
  ArEmailRemove,
  ArTemplateResponse,
  EmailQueueBulkRemoveResult,
  EmailQueueResponse,
  EmailSendBatch,
} from '../types/emailQueue';
import { arCollectionQueueApi } from './arCollectionsQueueApi';
import { FileCategory } from '../types/matter';
import _ from 'lodash';

class ReportingEmailQueueService {
  private readonly baseResource = '/ar-collections';

  async fetchEmailQueue(query: string): Promise<EmailQueueResponse> {
    const endpoint = `${this.baseResource}/email-queue${query ? `?${query}` : ''}`;

    return await api.get<EmailQueueResponse>(endpoint);
  }

  async sendArEmail(formData: EmailSendBatch) {
    const body = _.cloneDeep(formData);
    for (const item of body.items) {
      for (const attachment of item.attachments || []) {
        if (attachment.file) {
          const body = {
            name: attachment.file.name,
            size: attachment.file.size,
            type: attachment.file.type,
            // The sign-url endpoint rejects a request without a category.
            category: FileCategory.COLLECTION_ATTEMPT,
          };
          const { data } = await arCollectionQueueApi.getSummaryFileSignUrl(body);
          const storageResponse = await fetch(data.signUrl, {
            method: 'PUT',
            body: attachment.file,
            headers: { 'Content-Type': attachment.file.type },
          });
          if (!storageResponse.ok) {
            throw new Error(
              `File storage rejected "${attachment.file.name}" (${storageResponse.status})`
            );
          }
          attachment.fileKey = data.key;
          delete attachment.file;
          delete (attachment as any).fileSize;
        }
      }
    }

    const endpoint = `${this.baseResource}/email-queue/send`;
    return await api.post<EmailQueueResponse>(endpoint, body);
  }

  async fetchTemplate(
    matterId: string,
    clientId: string,
    daysPastDue?: number | null,
    daysPastDueCap?: number | null
  ): Promise<ArTemplateResponse> {
    const params = new URLSearchParams();
    if (daysPastDue !== undefined && daysPastDue !== null) {
      params.append('daysPastDue', daysPastDue.toString());
    }
    if (daysPastDueCap !== undefined && daysPastDueCap !== null) {
      params.append('daysPastDueCap', daysPastDueCap.toString());
    }
    const endpoint = `${this.baseResource}/email-queue/${matterId}/clients/${clientId}/template${params.size > 0 ? `?${params.toString()}` : ''}`;
    return await api.get<ArTemplateResponse>(endpoint);
  }

  async removeEmailQueue(matterId: string, clientId: string, data: ArEmailRemove) {
    const endpoint = `${this.baseResource}/email-queue/${matterId}/clients/${clientId}/remove`;
    return await api.post<EmailQueueResponse>(endpoint, data);
  }

  async removeEmailQueueBulk(data: ArEmailRemove) {
    const endpoint = `${this.baseResource}/email-queue/bulk/remove`;
    return await api.post<EmailQueueBulkRemoveResult>(endpoint, data);
  }
}

export const reportingEmailQueueApi = new ReportingEmailQueueService();
